<template>
  <div class="extras-mg-cond">
    <div v-if="!reglas.length" class="extras-mg-cond__vacio">
      Todavia no hay reglas. Agrega una y elige a que filas se aplica.
    </div>

    <div
      v-for="(regla, indice) in reglas"
      :key="regla.id"
      class="extras-mg-cond__regla"
    >
      <div class="extras-mg-cond__cabecera">
        <Dropdown
          :value="regla.color"
          :disabled="readOnly"
          class="extras-mg-cond__color"
          @input="cambiarColor(indice, $event)"
        >
          <DropdownItem
            v-for="nombre in coloresDisponibles"
            :key="nombre"
            :name="nombre"
            :value="nombre"
          ></DropdownItem>
        </Dropdown>
        <div
          class="extras-mg-cond__muestra"
          :class="'background-color--' + regla.color"
        ></div>
        <ButtonIcon
          v-if="!readOnly"
          icon="iconoir-bin"
          class="extras-mg-cond__borrar"
          @click="borrarRegla(indice)"
        />
      </div>

      <ViewFieldConditionsForm
        :filters="regla.filters || []"
        :filter-groups="regla.filter_groups || []"
        :disable-filter="readOnly"
        :filter-type="regla.operator || 'AND'"
        :fields="fields"
        :view="view"
        :read-only="readOnly"
        add-condition-string="Agregar condicion"
        @addFilter="agregarFiltro(indice)"
        @updateFilter="actualizarFiltro(indice, $event)"
        @deleteFilter="borrarFiltro(indice, $event)"
        @updateFilterType="cambiarOperador(indice, $event)"
      />
    </div>

    <a v-if="!readOnly" class="extras-mg-cond__agregar" @click="agregarRegla">
      + Agregar color
    </a>
  </div>
</template>

<script>
import { ulid } from 'ulid'

import Dropdown from '@baserow/modules/core/components/Dropdown'
import DropdownItem from '@baserow/modules/core/components/DropdownItem'
import ButtonIcon from '@baserow/modules/core/components/ButtonIcon'
import ViewFieldConditionsForm from '@baserow/modules/database/components/view/ViewFieldConditionsForm'
import { colors } from '@baserow/modules/core/utils/colors'

export default {
  name: 'FormaColorCondicional',
  components: { Dropdown, DropdownItem, ButtonIcon, ViewFieldConditionsForm },
  props: {
    fields: { type: Array, required: true },
    options: { type: Object, required: false, default: () => ({}) },
    readOnly: { type: Boolean, required: false, default: false },
    view: { type: Object, required: false, default: null },
    table: { type: Object, required: false, default: null },
    database: { type: Object, required: false, default: null },
  },
  data() {
    return {
      // Copia local: el padre solo recibe el conf completo en cada cambio.
      reglas: JSON.parse(JSON.stringify(this.options?.colors || [])),
    }
  },
  computed: {
    coloresDisponibles() {
      return colors
    },
  },
  watch: {
    options: {
      deep: true,
      handler(nuevo) {
        this.reglas = JSON.parse(JSON.stringify(nuevo?.colors || []))
      },
    },
  },
  methods: {
    emitir() {
      this.$emit('update', { colors: this.reglas })
    },
    agregarRegla() {
      this.reglas.push({
        id: ulid(),
        color: colors[0],
        filters: [],
        filter_groups: [],
        operator: 'AND',
      })
      this.emitir()
    },
    borrarRegla(indice) {
      this.reglas.splice(indice, 1)
      this.emitir()
    },
    cambiarColor(indice, color) {
      this.reglas[indice].color = color
      this.emitir()
    },
    cambiarOperador(indice, evento) {
      this.reglas[indice].operator = evento?.value || 'AND'
      this.emitir()
    },
    agregarFiltro(indice) {
      const campo = this.fields[0]
      if (!campo) {
        return
      }
      // Mismo criterio que el store del core: el primer tipo de filtro que sea
      // compatible con el campo elegido.
      const tipos = Object.values(this.$registry.getAll('viewFilter'))
      const tipo = tipos.find((t) => t.fieldIsCompatible(campo))
      if (!tipo) {
        return
      }
      this.reglas[indice].filters.push({
        id: ulid(),
        field: campo.id,
        type: tipo.getType(),
        value: '',
        group: null,
      })
      this.emitir()
    },
    actualizarFiltro(indice, { filter, values }) {
      const destino = this.reglas[indice].filters.find(
        (f) => f.id === filter.id
      )
      if (destino) {
        Object.assign(destino, values)
        this.emitir()
      }
    },
    borrarFiltro(indice, filtro) {
      this.reglas[indice].filters = this.reglas[indice].filters.filter(
        (f) => f.id !== filtro.id
      )
      this.emitir()
    },
  },
}
</script>

<style lang="scss">
.extras-mg-cond {
  padding: 8px 12px;
  max-width: 520px;
}

.extras-mg-cond__vacio {
  font-size: 12px;
  opacity: 0.6;
  padding: 4px 0 8px;
}

.extras-mg-cond__regla {
  border-top: 1px solid;
  border-top-color: color-mix(in srgb, currentColor 15%, transparent);
  padding: 8px 0;
}

.extras-mg-cond__cabecera {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}

.extras-mg-cond__color {
  flex: 1;
}

.extras-mg-cond__muestra {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  flex: none;
}

.extras-mg-cond__agregar {
  display: inline-block;
  font-size: 12px;
  margin-top: 8px;
  cursor: pointer;
}
</style>
